import * as Yup from 'yup'

const EMAIL = {
  email: Yup.string().email('Email Inválido.').required('Obligatorio'),
}

const USERNAME = {
  username: Yup.string()
    .strict(true)
    .trim('No inicie o termine con espacios en blanco.')
    .min(3, 'Nombre demasiado corto, digite más de 3 caracteres.')
    .max(50, 'Nombre demasiado largo, máx 50 caracteres.')
    .required('Obligatorio'),
}

const LASTNAME = {
  lastname: Yup.string()
    .strict(true)
    .trim('No inicie o termine con espacios en blanco.')
    .min(3, 'Apellido demasiado corto, digite más de 3 caracteres.')
    .max(50, 'Apellido demasiado largo, max. 50 caracteres.')
    .required('Obligatorio'),
}

const PHONE_CODE = {
  phone_code: Yup.string().notOneOf(['-1'], 'Obligatorio').required('Obligatorio'),
}

const PHONE = {
  phone_number: Yup.string()
    .required('Obligatorio')
    .matches(/^[0-9]{9,10}$/, 'Min. 9, max. 10 digitos'),
}

// Sin el 0 inicial: el código de país lo reemplaza (+593 987654321).
const PHONE_OPTIONAL = {
  phone_number: Yup.string()
    .trim()
    .matches(/^[1-9][0-9]{7,10}$/, {
      message: 'Solo dígitos, sin el 0 inicial (ej: 987654321)',
      excludeEmptyString: true,
    }),
}

const PHONE_JOIN = {
  phone_number_join: Yup.string()
    .required('Obligatorio')
    .matches(/^\+?[0-9]{1,4}[0-9]{9,10}$/, 'Formato inválido. Ej: +593XXXXXXXXX'),
}

const PASSWORD_LOGIN = {
  password_login: Yup.string()
    .strict(true)
    .trim('Evite espacios en blanco.')
    .required('Obligatorio'),
}

const PASSWORD = {
  password: Yup.string()
    .strict(true)
    .trim('Evite espacios en blanco.')
    .min(8, 'Contraseña demasiado corta, digite 8 caracteres como mínimo.')
    .max(16, 'Contraseña demasiado larga, digite 16 caracteres como máximo.')
    .matches(/^(?=\w*\d)\S/, 'Al menos un dígito.')
    .matches(/^(?=\w*[A-Z])\S/, 'Al menos una mayúscula.')
    .matches(/^(?=\w*[a-z])\S/, 'Al menos una minúscula.')
    .matches(/^(?=\w*[a-zA-Z0-9])\S{8,16}$/, 'Evite espacios en blanco.'),
}

const PASSWORD_CONFIRMATION = {
  password_confirmation: Yup.string().when('password', val => {
    if (val?.length > 0)
      return Yup.string()
        .oneOf([Yup.ref('password')], 'Las contraseñas no coinciden')
        .required('Obligatorio')

    return Yup.string().notRequired()
  }),
}

const PASSWORD_ALT = {
  password_alt: Yup.string()
    .strict(true)
    .trim('Evite espacios en blanco.')
    .min(8, 'Contraseña demasiado corta, digite 8 caracteres como mínimo.')
    .max(16, 'Contraseña demasiado larga, digite 16 caracteres como máximo.')
    .matches(/[0-9]/, 'Debe incluir al menos un dígito.')
    .matches(/[A-Z]/, 'Debe incluir al menos una mayúscula.')
    .matches(/[a-z]/, 'Debe incluir al menos una minúscula.')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Debe incluir al menos un símbolo (!@#$%^&*...).')
    .matches(/^\S*$/, 'Evite espacios en blanco.')
    .required('Obligatorio'),
}

const PASSWORD_CONFIRMATION_ALT = {
  password_confirmation_alt: Yup.string()
    .oneOf([Yup.ref('password_alt')], 'Las contraseñas no coinciden')
    .required('Obligatorio'),
}

const CODE = {
  code_: Yup.string()
    .max(20, 'Demasiado largo, máx. 20 caracteres.')
    .min(3, 'Demasiado corto, mín. 3 caracteres.')
    .required('Obligatorio'),
}

const SPECIE = {
  specie_: Yup.string()
    .max(35, 'Demasiado largo, 35 caracteres como máximo.')
    .required('Obligatorio'),
}

const CLASSIFIER = {
  clasificador_: Yup.string()
    .trim('No inicie o termine con espacios en blanco.')
    .max(80, 'Demasiado largo, 80 caracteres como máximo.')
    .notRequired(),
}

const TYPE_REQUESTED = {
  type_requested: Yup.string()
    .oneOf(['visitante', 'investigador'], 'Seleccione un tipo válido')
    .required('Obligatorio'),
}

const ROLE = {
  role: Yup.string()
    .oneOf(['investigador', 'visitante'], 'Seleccione un tipo válido')
    .required('Obligatorio'),
}

const FAMILY = {
  family_: Yup.string()
    .max(30, 'Demasiado largo, 30 caracteres como máximo.')
    .required('Obligatorio'),
}

const NEWS = {
  titulo: Yup.string()
    .max(150, 'Demasiado largo, 150 caracteres como máximo.')
    .required('Obligatorio'),
  url: Yup.string().url('URL inválida').required('Obligatorio'),
  contenido: Yup.string().min(10, 'Mínimo 10 caracteres.').required('Obligatorio'),
  idProyecto: Yup.string().required('Obligatorio'),
  habilitado: Yup.string().required('Obligatorio'),
  foto: Yup.string().notRequired(),
}

const SITE = {
  site_: Yup.string()
    .max(60, 'Demasiado largo, 60 caracteres como máximo.')
    .min(5, 'Demasiado corto, mín. 5 caracteres.')
    .required('Obligatorio'),
}

const SECTION = {
  section_: Yup.string().when('section_', val => {
    if (val?.length > 0) {
      return Yup.string()
        .max(200, 'Demasiado largo, 200 caracteres como máximo.')
        .required('Obligatorio')
    }
    return Yup.string().notRequired()
  }),
}

const PARISH = {
  parish_: Yup.string()
    .max(100, 'Demasiado largo, 100 caracteres como máximo.')
    .required('Obligatorio'),
}

const TYPE_SECTION = {
  typeSite_: Yup.string()
    .max(45, 'Demasiado largo, 45 caracteres como máximo.')
    .required('Obligatorio'),
}

const RECORDED = {
  recorded_: Yup.string()
    .max(75, 'Demasiado largo, 75 caracteres como máximo.')
    .required('Obligatorio'),
}

const ALIVE = {
  alive_: Yup.string().required('Obligatorio'),
}

const TREEVERIFIED = {
  treeVerified_: Yup.string().required('Obligatorio'),
}

const REGISTRATION_STATUS = {
  estadoRegistro: Yup.string()
    .oneOf(['no_verificado', 'en_revision', 'verificado'], 'Seleccione un estado válido')
    .required('Obligatorio'),
  observacionesRevision: Yup.array().when('estadoRegistro', {
    is: 'en_revision',
    then: Yup.array()
      .of(
        Yup.object().shape({
          texto: Yup.string().trim().required('Obligatorio'),
        }),
      )
      .test(
        'has-review-observations',
        'Agregue al menos una corrección',
        value => Array.isArray(value) && value.some(item => String(item?.texto || '').trim()),
      ),
    otherwise: Yup.array().notRequired(),
  }),
}

const COMMIT = {
  commit_: Yup.string().notRequired(),
}

const DATE = {
  date_: Yup.date()
    .min('01 Jan 2021', 'Fecha mínima mayor al Jan 2021')
    .required('Obligatorio')
    .typeError('Fecha no válida'),
}

const optionalNumber = () =>
  Yup.number().transform((value, originalValue) =>
    originalValue === '' || originalValue === null ? undefined : value,
  )

const ALTITUDE = {
  altitud: Yup.number()
    .max(5000, 'Altitud máxima 5000 msnm')
    .positive('Debe ser mayor a 0 msnm')
    .typeError('No es un número válido'),
}

const LONG = {
  longX: Yup.number().required('Obligatorio'),
}

const LAT = {
  latY: Yup.number().required('Obligatorio'),
}

const CAP = {
  cap: Yup.number()
    .min(0.5, 'CAP mínima 0.5 cm')
    .max(3000, 'CAP máxima 3000 cm')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const DAP = {
  dap: Yup.number()
    .min(1, 'DAP mínima 1 cm')
    .max(500, 'DAP máxima 500 cm')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const HT = {
  ht: Yup.number()
    .positive('HT mayor que 0 m')
    .max(100, 'HT máxima 100 m')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const HC = {
  hc: Yup.number()
    .positive('HC mayor que 0 m')
    .max(100, 'HC máxima 100 m')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const BIFURCACIONES = {
  bifurcaciones: optionalNumber()
    .integer('Ingrese números enteros')
    .min(0, 'Mínimo 0 bifurcaciones')
    .max(10, 'Máximo 10 bifurcaciones')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const INCL_ARBOL = {
  inclArbol: optionalNumber()
    .min(0, 'La inclinación no puede ser negativa')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const COMP_INCL_ARBOL = {
  compInclArbol: optionalNumber()
    .min(0, 'La compensación no puede ser negativa')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const CROWN_NS = {
  copaNS: Yup.number()
    .positive('Copa(NS) mayor que 0 m')
    .max(500, 'Copa(NS) máxima 500 m')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const CROWN_EW = {
  copaEW: Yup.number()
    .positive('Copa(EW) mayor que 0 m')
    .max(500, 'Copa(EW) máxima 500 m')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const FOLIAGE = {
  follaje: Yup.number()
    .integer('Ingrese números enteros')
    .min(0, 'Porcentaje mín. 0%')
    .max(100, 'Porcentaje máx. 100%')
    .typeError('No es un número válido')
    .required('Obligatorio'),
}

const MATURITY = options => ({
  madurez: Yup.string().when('madurez', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const BLOOMING = options => ({
  floracion: Yup.string().when('floracion', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const FRUCTIFICATION = options => ({
  fructificacion: Yup.string().when('fructificacion', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const STRAIGHTNESS = options => ({
  fusteRectitud: Yup.string().when('fusteRectitud', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const SPACING = options => ({
  espaciamiento: Yup.string().when('espaciamiento', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const oneOfIfValid = (options, message) =>
  options?.length > 0 ? Yup.string().oneOf(options, message) : Yup.string()

const ROOTQUALITY = options => ({
  calidadRaiz: Yup.string().when('calidadRaiz', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const FUSTEQUALITY = options => ({
  calidadFuste: Yup.string().when('calidadFuste', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const BARKQUALITY = options => ({
  calidadCorteza: Yup.string().when('calidadCorteza', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const BRANCHESQUALITY = options => ({
  calidadRamas: Yup.string().when('calidadRamas', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const LEAVESQUALITY = options => ({
  calidadHojas: Yup.string().when('calidadHojas', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const TOPQUALITY = options => ({
  calidadCima: Yup.string().when('calidadCima', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const CROWNQUALITY = options => ({
  calidadCopa: Yup.string().when('calidadCopa', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const RISKFALLING = options => ({
  rsgoCaida: Yup.string().when('rsgoCaida', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const CONSTRUCTIONRISK = options => ({
  rsgoAfeccionConstr: Yup.string().when('rsgoAfeccionConstr', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const INTERFCIRCULATION = options => ({
  rsgoInterfCirculacion: Yup.string().when('rsgoInterfCirculacion', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const INFRASTRUCTURERISK = options => ({
  rsgoInfraestructura: Yup.string().when('rsgoInfraestructura', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const ELECTRICALNETWORKSRISK = options => ({
  rsgoRedesElectricas: Yup.string().when('rsgoRedesElectricas', val => {
    if (val) return oneOfIfValid(options, 'Campo inválido').required('Obligatorio')
    return Yup.string().required('Obligatorio')
  }),
})

const OTHERSRISK = {
  riesgoOtros: Yup.string().when('riesgoOtros', val => {
    if (val?.length > 0)
      return Yup.string()
        .min(4, 'Mínimo 4 caracteres')
        .max(75, 'Máximo 75 caracteres')
        .required('Obligatorio')

    return Yup.string().notRequired()
  }),
}

const PRIORITY = {
  prioridadAtencion: Yup.string()
    .oneOf(['baja', 'media', 'alta', 'urgente'], 'Seleccione una prioridad válida')
    .required('La urgencia de intervención es obligatoria'),
}

export const schema = {
  EMAIL,
  USERNAME,
  LASTNAME,
  PHONE_CODE,
  PHONE,
  PHONE_OPTIONAL,
  PHONE_JOIN,
  PASSWORD,
  PASSWORD_ALT,
  PASSWORD_LOGIN,
  PASSWORD_CONFIRMATION,
  PASSWORD_CONFIRMATION_ALT,
  CODE,
  SPECIE,
  CLASSIFIER,
  FAMILY,
  NEWS,
  // PSEUDONYM,
  TYPE_REQUESTED,
  SITE,
  SECTION,
  PARISH,
  TYPE_SECTION,
  RECORDED,
  ALIVE,
  TREEVERIFIED,
  REGISTRATION_STATUS,
  COMMIT,
  DATE,
  ROLE,
  //Features
  ALTITUDE,
  LONG,
  LAT,
  CAP,
  DAP,
  HT,
  HC,
  BIFURCACIONES,
  INCL_ARBOL,
  COMP_INCL_ARBOL,
  CROWN_NS,
  CROWN_EW,
  FOLIAGE,
  MATURITY,
  BLOOMING,
  FRUCTIFICATION,
  STRAIGHTNESS,
  SPACING,
  // Inconveniences with options control input
  ROOTQUALITY,
  FUSTEQUALITY,
  BARKQUALITY,
  BRANCHESQUALITY,
  LEAVESQUALITY,
  TOPQUALITY,
  CROWNQUALITY,
  RISKFALLING,
  CONSTRUCTIONRISK,
  INTERFCIRCULATION,
  INFRASTRUCTURERISK,
  ELECTRICALNETWORKSRISK,
  OTHERSRISK,
  PRIORITY,
}
